import { gql, useMutation } from '@apollo/client';
import LOCALIZED_TEXT_FRAGMENT from 'apollo/fragments/localizedText';
import { LocalizedCreatePackInput, LocalizedPack } from 'apollo/localizedTypes';

const CREATE_PACK = gql`
  mutation createPack($input: CreatePackInput!) {
    createPack(input: $input) {
      id
      adultValue
      description {
        ...LocalizedTextFields
      }
      name {
        ...LocalizedTextFields
      }
      otherValue
      status
    }
  }
  ${LOCALIZED_TEXT_FRAGMENT}
`;

const useCreatePackMutation = () => {
  return useMutation<
    { createPackType: LocalizedPack },
    { input: LocalizedCreatePackInput }
  >(CREATE_PACK, {});
};
export default useCreatePackMutation;
